import { applyQueryStringFilters } from "../../utils/devextreme_utils";

/**
 * Apply filters to DataGrid
 * Set all columns to visible = false, and set visible: true only to filtered colums and columns that are visible by default.
 *
 * @param {Object} datagrid
 * @param {Array} visibleColumnByDefault - default visible columns
 * @returns {import("../datagrid").Plugin}
 */
export function applyQueryStringFiltersPlugin({ visibleColumnByDefault = [] }) {
  return {
    name: "applyQueryStringFilters",
    onDataGridCreated() {
      const dataGrid = this;
      applyQueryStringFilters(dataGrid, visibleColumnByDefault);
    },
  };
}
